import { render } from "./UserRightsSection.vue?vue&type=template&id=3795ab28"
import script from "./UserRightsSection.vue?vue&type=script&lang=js"
export * from "./UserRightsSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__